import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useNavigate, Navigate } from "react-router-dom";

import Navbar from "../components/Navbar";
import zipzyAdminApiClient from "../apiClients/zipzyAdminApiClient";

export default function Homepage() {
  const isLoggedIn = zipzyAdminApiClient.isLoggedIn();

  const navigate = useNavigate();

  if (!isLoggedIn) {
    return <Navigate to="/auth/login" replace />;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      height="100vh"
      textAlign="center"
    >
      <Navbar />

      <Typography variant="h5" gutterBottom sx={{ mb: 4 }}>
        What Would You Like To Do?
      </Typography>

      <Button variant="contained" onClick={() => navigate("/db/users/add")} sx={{ mb: 2 }}>
        Add A New User
      </Button>

      <Button variant="contained" onClick={() => navigate("/analytics/drivers")} sx={{ mb: 2 }}>
        View Drivers Status
      </Button>

      <Button variant="contained" onClick={() => navigate("/analytics/rides")} sx={{ mb: 2 }}>
        View Rides Stats
      </Button>

      <Button variant="contained" onClick={() => navigate("/analytics/metrics-report")} sx={{ mb: 2 }}>
        Metrics Report
      </Button>

      <Button variant="contained" onClick={() => navigate("/db/vehicle-assignments")} sx={{ mb: 2 }}>
        Vehicle Assignment
      </Button>
    </Box>
  );
}
